module.exports = __webpack_public_path__ + "static/img/Zach-Fittler.1a24e62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zach-Fittler.jpg
// module id = 5rv9
// module chunks = 0